import React from "react";
import moment from "moment";

function Index({ flight, fare }) {
  let { heading, details, operator, segments } = flight;
  const startTime = moment(details.departure);
  const endTime = moment(details.arrival);
  const duration = moment.duration(endTime.diff(startTime));
  const hours = parseInt(duration.asHours());
  const minutes = parseInt(duration.asMinutes()) % 60;
  function formatTerminal(terminalValue) {
    if (typeof terminalValue !== 'string' || !terminalValue) return '';
  
    const lowerValue = terminalValue.toLowerCase();
    
    if (!lowerValue.includes("terminal")) {
      return `Terminal - ${terminalValue}`;
    }
  
    return terminalValue;
  }
  return (
    <>
      <div>
        <div className="FadeUp-Effect d-flex align-items-center justify-content-between mb-3">
          <div>
            <h4 className="m-0">{heading}</h4>
            {startTime?.format("DD MMM YY")}
          </div>
          <div>
            <img
              alt="Airline_logo"
              className="me-2 ms-3"
              src={operator?.logo}
              style={{
                width: 25,
                height: 25,
                objectFit: "cover",
                borderRadius: 30,
              }}
            />
            <span className="text-small">{operator?.name}</span> &nbsp;&nbsp;
            <span className="text-muted text-small">
              {operator?.code}-{operator?.number}
            </span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            gap: '16px',
            border: '1px solid #E7E7E7',
            borderRadius: '12px',
          }}
        >
          <div style={{width: '100%'}}>
            <img
              alt="Airline_logo"
              className="me-1"
              src={operator?.logo}
              style={{
                width: 18,
                height: 18,
                objectFit: "cover",
                borderRadius: 30,
              }}
            />
            <span className="text-small">{operator?.name}</span> &nbsp;&nbsp;
            <span className="text-muted text-small">
              {operator?.code}-{operator?.number}
            </span>
          </div>
          <div style={{display: 'flex', width: '100%', justifyContent: 'space-around', alignItems: 'center'}}>
              <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                <p style={{margin: '0px'}}>{startTime?.format("HH:mm")}</p>
                <p style={{margin: '0px'}}>{segments[0]?.departure?.code}</p>
                <p style={{margin: '0px', fontSize: '12px'}}>{segments[0]?.departure?.airport}</p>
                <p style={{margin: '0px', fontSize: '12px'}}>{formatTerminal(segments[0]?.departure?.terminal)}</p>
              </div>
              <div style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '4px'}}>
                <p style={{margin: '0px', fontSize: '12px', fontWeight: 500}}>{hours}h {minutes}m</p>
                <p className="flight-dash-line" />
                <div style={{display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'center'}} className="truncate-container">
                <p style={{margin: '0px', fontSize:'12px', fontWeight: 500, color: '#808080'}}>{segments?.length > 1
                    ? `${segments?.length - 1} Stop`
                    : "Non-Stop"}</p>
                {
                  segments?.length > 1 &&
                <p style={{margin: '0px', fontSize:'12px', fontWeight: 500, color: '#808080'}}>
                  {segments.map((leg, index) => {
                    if (index === 0) {
                      return <></>;
                    }
                    return <span> ( {leg?.departure?.city} )</span>;
                  })}
                </p>
                }
                </div>
              </div>
              <div style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end'}}>
                <p style={{margin: '0px'}}>{endTime?.format("HH:mm")}</p>
                <p style={{margin: '0px'}}>{segments[segments?.length - 1]?.arrival?.code}</p>
                <p style={{margin: '0px', fontSize: '12px', textAlign: 'right'}}>{segments[segments?.length - 1]?.arrival?.airport}</p>
                <p style={{margin: '0px', fontSize: '12px', textAlign: 'right'}}>{formatTerminal(segments[segments?.length - 1]?.arrival?.terminal)}</p>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
